import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { 
  LayoutDashboard, 
  Bell, 
  History, 
  Settings,
  Shield,
  Map,
  Activity
} from 'lucide-react';

const AppBottomNav = () => {
  const { t } = useLanguage();
  const { isAdmin } = useAuth();
  const location = useLocation();

  const navItems = [
    { path: '/app', icon: LayoutDashboard, label: 'Dashboard', labelZh: '控制台' },
    { path: '/app/telemetry', icon: Activity, label: 'Live', labelZh: '即時' },
    { path: '/app/map', icon: Map, label: 'Map', labelZh: '地圖' },
    { path: '/app/alerts', icon: Bell, label: 'Alerts', labelZh: '警報' },
    { path: '/app/settings', icon: Settings, label: 'Settings', labelZh: '設定' },
  ];

  if (isAdmin) {
    navItems.push({ path: '/app/admin', icon: Shield, label: 'Admin', labelZh: '管理' });
  }

  const isActive = (path) => {
    if (path === '/app') {
      return location.pathname === '/app' || location.pathname.startsWith('/app/device/');
    }
    return location.pathname === path;
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-fac-card border-t border-border md:hidden z-40 pb-safe">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={`flex flex-col items-center justify-center w-full h-full transition-colors ${
              isActive(item.path)
                ? 'text-fac-green'
                : 'text-muted-foreground hover:text-white'
            }`}
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            <item.icon className="w-5 h-5 mb-1" />
            <span className="text-xs font-chinese">{item.labelZh}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default AppBottomNav;
